import addToCartRoute from "./add-to-cart-route";
import getCartRoute from "./get-cart-route";
import placeOrderRoute from "./place-order-route";
import removeFromCartRoute from "./remove-from-cart-route";
import getOrderRoute from "./get-order-route";
// import verifyCartRoute from "./verify-cart-route";

export default {
  // "verify-cart": verifyCartRoute,
  "place-order": placeOrderRoute,
  "add-to-cart": addToCartRoute,
  "remove-from-cart": removeFromCartRoute,
  "get-cart": getCartRoute,
  "get-order": getOrderRoute,
};
